import React, { useEffect, useState } from "react";
import WrappedMap from "./gmap";
import moment from "moment";
import { Box, Button, Grid, InputAdornment, LinearProgress, Snackbar, TextField, Typography } from "@mui/material";
import RangeDatePicker from "../../../UI/AppDatePickerClick/AppDatePicker";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { useSearchParams } from "react-router-dom";

export interface Path {
  time_stamp: any;
  home_long: number;
  home_lat: number;
  rideId: number;
  cycleId: number;
  latitude: number;
  longitude: number;
  createdTime: string;
  Distance: number;
  Location: number;
  work_long: number;
  work_lat: number;
  Date: string;
  Start_time: string;
  End_time: string;
  time_diff: number;
  date: string;
}

function App(props: any) {
  const [mapdata, setMapData] = useState<Path[]>([]);
    const [loaderpassword, setLoaderpassword] = useState(false);
  const [searchValInput, setSearchValInput] = useState<string | null>(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

 const handleSearchClick = () => {
  let isMounted = true;
  setLoaderpassword(true);

  const effectiveStartDate = startDate
    ? moment(startDate)
    : moment().subtract(7, "days");

  const effectiveEndDate = endDate ? moment(endDate) : moment();

  const formattedStartDate = effectiveStartDate.format("DD-MM-YYYY");
  const formattedEndDate = effectiveEndDate.format("DD-MM-YYYY");

  fetch(
    `https://data.bcykal.com/tracker/mobile_data/get/details/user_id/${searchValInput}?start_date=${formattedStartDate}&end_date=${formattedEndDate}`
  )
    .then((res) => {
      // 🔥 fetch ka MOST IMPORTANT FIX
      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`);
      }
      return res.json();
    })
    .then((data) => {
      if (!isMounted) return;

      if (data?.success === true && Array.isArray(data?.data)) {
        setMapData(data.data);
      } else {
        setMapData([]);
        setSnackbarMessage("Please search valid EV number first");
        setSnackbarOpen(true);
      }
    })
    .catch((err) => {
      // ✅ console only
      console.error("Mobile data API failed:", err);

      if (!isMounted) return;

      setMapData([]);
      setSnackbarMessage("API Error. Please try again.");
      setSnackbarOpen(true);
    })
    .finally(() => {
      // 🔥 loader ALWAYS stops
      if (isMounted) setLoaderpassword(false);
    });

  return () => {
    isMounted = false;
  };
};



  const handleClearSearch = () => {
    setSearchValInput("");
  };
useEffect(() => {
  const end = moment().subtract(2, "days");     // Today - 2
  const start = moment(end).subtract(7, "days"); // Last 7 days from end

  setStartDate(start.toDate());
  setEndDate(end.toDate());
}, []);
  const handleDateChange = (start: Date | null, end: Date | null) => {
    setStartDate(start || null);
    setEndDate(end || null) ;
  };
const [searchParams] = useSearchParams();

useEffect(() => {
  const ebFromUrl = searchParams.get("eb");

  if (ebFromUrl) {
    setSearchValInput(ebFromUrl);

    setTimeout(() => {
      handleSearchClick(); // 🔍 auto API call

      // 🧹 URL clean (THIS LINE)
      window.history.replaceState(
        {},
        "",
        window.location.pathname
      );
    }, 0);
  }
}, []);

const handleDownloadCSV = async () => {
  try {
    const effectiveStartDate = startDate
      ? moment(startDate)
      : moment().subtract(9, "days");

    const effectiveEndDate = endDate
      ? moment(endDate)
      : moment().subtract(2, "days");

    const formattedStartDate = effectiveStartDate.format("DD-MM-YYYY");
    const formattedEndDate = effectiveEndDate.format("DD-MM-YYYY");

    const response = await fetch(
    `https://data.bcykal.com/tracker/mobile_data/get/details/user_id/${searchValInput}?start_date=${formattedStartDate}&end_date=${formattedEndDate}`
    );

    const result = await response.json();

    if (!result?.success || !result?.data?.length) {
      setSnackbarMessage("Please Search valid EV Number First");
      setSnackbarOpen(true);
      return;
    }

    const data = result.data;

    // Convert JSON → CSV
    const headers = Object.keys(data[0]).join(",");
    const rows = data.map((row: any) =>
      Object.values(row)
        .map((val) => `"${val ?? ""}"`)
        .join(",")
    );

    const csvContent = [headers, ...rows].join("\n");

    // Download CSV
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `rider_data_${formattedStartDate}_to_${formattedEndDate}.csv`
    );

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  } catch (error) {
    setSnackbarMessage("Failed to download CSV");
    setSnackbarOpen(true);
  }
};

  return (
    <div style={{ height: 600, width: `100%` }}>
      <Grid container>
        {loaderpassword && (
          <Grid item sm={12} lg={12}>
            <LinearProgress
              sx={{
                backgroundColor: "white",
                "& .MuiLinearProgress-bar": {
                  backgroundColor: "#00CD5B",
                },
              }}
            />
          </Grid>
        )}
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={9000}
          onClose={() => setSnackbarOpen(false)}
          message={snackbarMessage}
        />
        <div className="flex m-4 mt-6 ml-6">
          <TextField
            placeholder="Search QRCode"
            id="outlined-basic"
            variant="outlined"
            onChange={(search: any) => setSearchValInput(search.target.value)}
            value={searchValInput}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end" onClick={handleClearSearch}>
                  <ClearIcon style={{ cursor: "pointer" }} />
                </InputAdornment>
              ),
              style: { height: "40px" },
            }}
          />
          <div className="flex items-center ml-8 gap-4">
  <p className="mr-2 font-semibold">Select Date Range:</p>

  <RangeDatePicker
    onChange={handleDateChange}
    maxDaysAdd={0}
    minDaysSub={92}
    defaultStartDate={8}
    defaultEndDate={-2}
  />

  <Button
    variant="outlined"
    sx={{
      height: "38px",
      textTransform: "none",
      borderColor: "#00CD5B",
      color: "#00CD5B",
      "&:hover": {
        backgroundColor: "#00CD5B16",
        borderColor: "#00CD5B",
      },
    }}
    onClick={handleDownloadCSV}
  >
    Download Rider Data
  </Button>
</div>

          <Button
            sx={{
              bgcolor: "#FF725E33",
              color: "black",
              ml: 2,
              mr: 2,
              textTransform: "none",
              "&:hover": { bgcolor: "#FF725E16" },
            }}
            type="submit"
            onClick={handleSearchClick}
          >
            Search
          </Button>
        </div>
      </Grid>
      <div style={{ position: 'relative' }}>
        {mapdata && mapdata.length > 0 ? (
          <div style={{ height: "100%", width: "100%" }}>
            
            <WrappedMap
              paths={mapdata.sort((o1, o2) => o1.Distance - o2.Distance)}
            />
          </div>
        ) : (
          <Box sx={{ width: "100%" }}>
            <Typography variant="subtitle1">Please Search Rider EB Number</Typography>
          </Box>
        )}
      </div>
    </div>
  );
}

export default App;
